import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ORDER_TYPES } from 'shared-modules/constants/manualTrade';
import {
  BUY_SELL_VALUE,
  CFD,
  EXPIRATION_TYPE_MAIN,
  EXPIRATION_TYPE_VALUES,
  ORDER_METHOD_VALUE,
} from 'shared-modules/constants';
import { useGetInstrumentDisplayName } from 'shared-modules/hooks';
import { createDateString, getServiceQuantityUnit, trimFrontZeros } from 'shared-modules/services';
import useFormatPrice from '../../hooks/useFormatPrice';
import styles from './standardOrder.module.scss';

const StandardOrder = () => {
  const serviceId = useSelector((state) => state.auth.serviceId);
  const quantityUnit = getServiceQuantityUnit(serviceId);
  const instrumentId = useSelector((state) => state.manualTrade.selectedInstrumentId[serviceId]);
  const formatPrice = useFormatPrice(instrumentId);
  const getInstrumentDisplayName = useGetInstrumentDisplayName();
  const { quantityUnitConvFactor } = useSelector((state) => state.settings.instrumentList[instrumentId]);
  const orderMethod = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.ORDER_METHOD],
  );
  const buySell = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.BUY_SELL],
  );
  const count = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.COUNT],
  );
  const price = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.PRICE],
  );
  const expirationType = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.EXPIRATION_TYPE],
  );
  const selectedDate = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.SELECTED_DATE],
  );
  const selectedTime = useSelector(
    (state) => state.manualTrade.createOrders[ORDER_TYPES.STANDARD.name][ORDER_TYPES.STANDARD.inputs.SELECTED_TIME],
  );

  const isCFD = useMemo(() => serviceId === CFD, [serviceId]);

  return (
    <>
      <div className={styles.headerRow}>新規</div>
      <div className={styles.brandRow}>
        銘柄
        <span>{getInstrumentDisplayName(instrumentId, serviceId)}</span>
      </div>
      <div className={styles.orderTypeRow}>
        注文条件
        <span>{ORDER_METHOD_VALUE[orderMethod]}</span>
      </div>
      <div className={styles.buySellRow}>
        売買
        <span>{BUY_SELL_VALUE[buySell]}</span>
      </div>
      <div className={styles.countRow}>
        <div>
          数量
          {isCFD && <div>1Lot={quantityUnitConvFactor}</div>}
        </div>
        <span className={styles.boldText}>{`${trimFrontZeros(count)}${quantityUnit}`}</span>
      </div>
      <div className={styles.priceRow}>
        価格
        <span>{formatPrice(price)}</span>
      </div>
      <div className={styles.expirationTypeRow}>
        有効期限
        <span>
          {expirationType === EXPIRATION_TYPE_MAIN.CUSTOM.ID
            ? createDateString(selectedDate, selectedTime, true)
            : EXPIRATION_TYPE_VALUES[expirationType]}
        </span>
      </div>
    </>
  );
};

export default memo(StandardOrder);
